import { render } from "./SkeletonProductCard.vue?vue&type=template&id=379f5986&scoped=true"
import script from "./SkeletonProductCard.vue?vue&type=script&lang=js"
export * from "./SkeletonProductCard.vue?vue&type=script&lang=js"

import "./SkeletonProductCard.vue?vue&type=style&index=0&id=379f5986&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379f5986"]])

export default __exports__